export default __webpack_public_path__ + "media/color/gin-9264b937.svg";